import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { AccountService } from '@app/services/account.service';
import { ValidatedInputComponent } from '@app/ui-components/validated-input/validated-input.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-forgott-password',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    ValidatedInputComponent,
  ],
  templateUrl: './forgott-password.component.html',
  styleUrl: './forgott-password.component.scss',
})
export class ForgottPasswordComponent {
  form: FormGroup;
  errorMessage = '';
  loading = false;
  requestSent = false;

  private accountService = inject(AccountService);
  private router = inject(Router);
  private translate = inject(TranslateService);

  constructor(fb: FormBuilder) {
    this.form = fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.loading = true;
    this.errorMessage = '';

    this.accountService
      .forgotPassword({ email: this.form.controls['email'].value })
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (response: { success?: boolean; errors?: string[] }) => {
          if (response && response.success === false) {
            this.errorMessage =
              response.errors?.join(' ') ??
              this.translate.instant('forgottenPassword.requestFailed');
            return;
          }
          this.requestSent = true;
        },
        error: () => {
          this.errorMessage = this.translate.instant(
            'forgottenPassword.requestFailed',
          );
        },
      });
  }

  cancel(): void {
    void this.router.navigate(['/auth/login']);
  }
}
